import React from "react";
import weFightTogether from "../../assets/images/reasons/we-fight-togother.jpg";
import weCareAbout from "../../assets/images/reasons/we-care-about.jpg";
const Reasons = () => (
  <div className="section-home home-reasons">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="reasons-col animate-onscroll fadeIn">
            <img src={weFightTogether} alt="" />

            <div className="reasons-titles">
              <h3 className="reasons-title">We fight together</h3>
              <h5 className="reason-subtitle">We are humans</h5>
            </div>

            <div className="on-hover hidden-xs">
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Tenetur praesentium, itaque facilis nesciunt ab omnis cumque
                similique ipsa veritatis perspiciatis, harum ad at nihil
                molestias, dignissimos sint consequuntur. Officia, fuga.
              </p>

              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Tenetur praesentium, itaque facilis nesciunt ab omnis cumque
                similique ipsa veritatis perspiciatis, harum ad at nihil
                molestias, dignissimos sint consequuntur. Officia, fuga.
              </p>

              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Tenetur praesentium, itaque facilis nesciunt ab omnis cumque
                similique ipsa veritatis perspiciatis, harum ad at nihil
                molestias, dignissimos sint consequuntur. Officia, fuga.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="reasons-col animate-onscroll fadeIn">
            <img src={weCareAbout} alt="" />

            <div className="reasons-titles">
              <h3 className="reasons-title">WE care about others</h3>
              <h5 className="reason-subtitle">We are humans</h5>
            </div>

            <div className="on-hover hidden-xs">
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Tenetur praesentium, itaque facilis nesciunt ab omnis cumque
                similique ipsa veritatis perspiciatis, harum ad at nihil
                molestias, dignissimos sint consequuntur. Officia, fuga.
              </p>

              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Tenetur praesentium, itaque facilis nesciunt ab omnis cumque
                similique ipsa veritatis perspiciatis, harum ad at nihil
                molestias, dignissimos sint consequuntur. Officia, fuga.
              </p>

              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Tenetur praesentium, itaque facilis nesciunt ab omnis cumque
                similique ipsa veritatis perspiciatis, harum ad at nihil
                molestias, dignissimos sint consequuntur. Officia, fuga.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Reasons;
